import Token from '@/utils/Token';

export default {

    parse(data) {
        return data;
    },
    get(id, params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/aprovacao/${id}${params}`, Token.getHeader());
    },
    list(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/aprovacao/list${params}`, Token.getHeader());
    },

    executar(id) {
        return axios.post(`/api/aprovacao/executar/${id}`, {}, Token.getHeader());
    },
    create(params) {
        return axios.post(`/api/aprovacao`, params, Token.getHeader());
    },
    update(id,params) {
        return axios.post(`/api/aprovacao/${id}`, params, Token.getHeader());
    },
    delete(id) {
        return axios.delete(`/api/aprovacao/${id}`, Token.getHeader());
    },
}
